import React from 'react';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PersonIcon from '@material-ui/icons/Person';
import RoomIcon from '@material-ui/icons/Room';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { Button, TextField } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CheckIcon from '@material-ui/icons/Check';
import EditSoldPackageConfirmationBox from './EditSoldPackageConfirmationBox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';



export interface IEditPackageComponentProps {
    language: string,
    uniquePackageNameCheckResult: any,
    allTokenUsages: any,
    allAgeGroups: any,
    allGenres: any,
    allTerms: any,
    allSites: any,
    selectedPackageDetails: any,
    confirmEditTokenPackage: (newPackageDetails: any, changeAllTargetedSoldPackage: boolean) => Promise<void>,
    uniquePackageNameCheck: (packageName: string) => void

}

export interface IEditPackageComponentState {
    uniquePackageName: string,
    uniquePackageNameResult: boolean,
    createPackageSteps: any[],
    activeStep: number
    packageType: any,
    addGenre: boolean,
    newPackageDetails: any,
    showEditSoldPackageConfirmationBox: boolean
}

class EditPackageComponent extends React.Component<IEditPackageComponentProps, IEditPackageComponentState> {
    constructor(props: IEditPackageComponentProps) {
        super(props);
        this.state = {
            uniquePackageName: "",
            uniquePackageNameResult: false,
            createPackageSteps: (this.props.language !== "eng" ? ['套券名稱', '套券內容', '掛勾條款', '確認套券詳情'] : ['Package Name', 'Package Details', 'Package Terms', 'Confirm Package']),
            activeStep: 0,
            packageType: '',
            addGenre: false,
            newPackageDetails: {
                package_name: "",
                token_usage_id: 0,
                age_group_id: 0,         //CLASS
                genre_id: [],             //CLASS
                token_amount: 1,            //CLASS PRIVATE RENTAL TUTOR
                validate_period: 30,        //CLASS PRIVATE RENTAL TUTOR
                effective_time: 0,       //PRIVATE RENTAL
                price: "0.00",                 //CLASS PRIVATE RENAL TUTOR
                site_id: 0,              //CLASS PRIVATE RENTAL TUTOR
                token_based_package: true,  //CLASS
                package_terms: null         //CLASS PRIVATE RENTAL TUTOR
            },
            showEditSoldPackageConfirmationBox: false

        }
    }

    private handlePreviousStepClick = async () => {
        await this.setState({
            activeStep: this.state.activeStep - 1
        })
    }

    private handleNextStepClick = async () => {
        await this.setState({
            activeStep: this.state.activeStep + 1
        })
    }

    private handlePackageNameInput = async (event: any) => {
        await this.setState({
            newPackageDetails: {
                ...this.state.newPackageDetails,
                package_name: event.target.value
            }
        })
    }
    private handleAgeGroupInput = async (event: any) => {

        await this.setState({
            newPackageDetails: {
                ...this.state.newPackageDetails,
                age_group_id: event.target.value
            }
        })

    }
    private handleAddNewGenre = async () => {
        await this.setState({
            addGenre: true
        })
    }

    private handleGenreInput = async (event: any) => {
        if (this.state.newPackageDetails.genre_id !== 0) {
            let newGenreIDs = this.state.newPackageDetails.genre_id;
            newGenreIDs.push(event.target.value)
            await this.setState({
                addGenre: false,
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    genre_id: newGenreIDs
                }
            })
        } else {
            await this.setState({
                addGenre: false,
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    genre_id: [event.target.value]
                }
            })
        }
    }

    private handleDelGenre = async (genreID: number) => {
        let newGenreIDs = this.state.newPackageDetails.genre_id;
        newGenreIDs = await newGenreIDs.filter((genre: any) => genre !== genreID);

        if (newGenreIDs.length === 0) {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    genre_id: []
                }
            })
        } else {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    genre_id: newGenreIDs
                }
            })
        }
    }
    private handleTokenAmountInput = async (event: any) => {
        let value = parseInt(`${event.target.value}`)
        if (value > 0) {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    token_amount: value
                }
            })
        } else {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    token_amount: 0
                }
            })
        }
    }
    private handleTokenBasedPackageChange = async (event: any) => {
        if (this.state.newPackageDetails.token_based_package) {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    token_based_package: !this.state.newPackageDetails.token_based_package,
                    token_amount: 1
                }
            })
        } else {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    token_based_package: !this.state.newPackageDetails.token_based_package,
                }
            })
        }

    }

    private handleEffectiveTimeInput = async (event: any) => {
        let value = parseInt(`${event.target.value}`)
        if (value > 0) {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    effective_time: value
                }
            })
        } else {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    effective_time: 0
                }
            })
        }
    }
    private handleValidatePeriodInput = async (event: any) => {
        let value = parseInt(`${event.target.value}`)
        if (value > 0) {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    validate_period: value
                }
            })
        } else {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    validate_period: 0
                }
            })
        }
    }
    private handlePriceInput = async (event: any) => {
        let value = parseFloat(`${event.target.value}`)
        if (value > 0) {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    price: value.toFixed(2)
                }
            })
        } else {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    price: "0.00"
                }
            })
        }
    }

    private handleTermsClick = async (termID: number) => {
        if (this.state.newPackageDetails.package_terms) {
            if (this.state.newPackageDetails.package_terms.includes(termID)) {
                let newTerms = await this.state.newPackageDetails.package_terms.filter((term: any) => term !== termID)
                if (newTerms.length !== 0) {
                    await this.setState({
                        newPackageDetails: {
                            ...this.state.newPackageDetails,
                            package_terms: newTerms
                        }
                    })
                } else {
                    await this.setState({
                        newPackageDetails: {
                            ...this.state.newPackageDetails,
                            package_terms: null
                        }
                    })
                }
            } else {
                let newTerms = this.state.newPackageDetails.package_terms
                newTerms.push(termID)
                await this.setState({
                    newPackageDetails: {
                        ...this.state.newPackageDetails,
                        package_terms: newTerms
                    }
                })
            }
        } else {
            await this.setState({
                newPackageDetails: {
                    ...this.state.newPackageDetails,
                    package_terms: [termID]
                }
            })
        }
    }
    private handleConfirmAddClick = async (confirmation: boolean) => {
        let newPackageDetails = this.state.newPackageDetails
        if (newPackageDetails.age_group_id === 0) {
            newPackageDetails = {
                ...newPackageDetails,
                age_group_id: null
            }
        }
        if (newPackageDetails.effective_time === 0) {
            newPackageDetails = {
                ...newPackageDetails,
                effective_time: null
            }
        }
        if (newPackageDetails.genre_id.length === 0) {
            newPackageDetails = {
                ...newPackageDetails,
                genre_id: null
            }
        }
        if (newPackageDetails.site_id === 0) {
            newPackageDetails = {
                ...newPackageDetails,
                site_id: null
            }
        }
        this.props.confirmEditTokenPackage(newPackageDetails, confirmation);
    }
    private handleSiteInput = async (event: any) => {
        await this.setState({
            newPackageDetails: {
                ...this.state.newPackageDetails,
                site_id: event.target.value
            }
        })
    }

    private handleShowEditSoldPackageConfirmationBoxBtn = async () => {
        await this.setState({
            showEditSoldPackageConfirmationBox: !this.state.showEditSoldPackageConfirmationBox
        })
    }

    async componentWillMount() {
        let packageType = (await this.props.allTokenUsages.filter((usage: any) => usage.id === this.props.selectedPackageDetails.token_usage_id))[0]
        await this.setState({
            packageType: packageType,
            newPackageDetails: {
                ... this.props.selectedPackageDetails,
                age_group_id: (this.props.selectedPackageDetails.age_group_id ? this.props.selectedPackageDetails.age_group_id : 0),
                genre_id: (this.props.selectedPackageDetails.genre_id ? this.props.selectedPackageDetails.genre_id : []),
                site_id: (this.props.selectedPackageDetails.site_id ? this.props.selectedPackageDetails.site_id : 0)
            }
        })
    }

    componentDidUpdate() {
        if (this.state.newPackageDetails.package_name !== this.props.uniquePackageNameCheckResult.packageName) {
            this.props.uniquePackageNameCheck(this.state.newPackageDetails.package_name);
        }
    }
    render() {
        return (
            <div className="systemMainDisplayArea row">
                {
                    !this.state.showEditSoldPackageConfirmationBox ? null : <EditSoldPackageConfirmationBox handleExit={(confirmation: boolean) => this.handleConfirmAddClick(confirmation)} language={this.props.language} />

                }
                <div className="systemManagePageTitle"> <ConfirmationNumberIcon id="systemManPageTitleIcon" /> {this.props.language !== "eng" ? "套券管理" : "Package Manage"}</div>
                <div className="newPackageTitleRow"><div>{this.props.language !== "eng" ? "更改套券" : "Edit Package"}</div></div>
                <div className="stepsIndicatorRow">
                    <Stepper id="stepIconColor" activeStep={this.state.activeStep} alternativeLabel>
                        {this.state.createPackageSteps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </div>
                <div className="fixedHeightWindowOnNewPackageComponent">
                    <div className="mainInputRow">
                        {

                            this.state.activeStep === 0 ?
                                //SECOND STEP
                                <div className="tokenNameInputContainer col-12">
                                    <div className="inputRowOnAddPackageComponent row">
                                        <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "套券名稱" : "Package Name"} :</div>
                                        <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                            <TextField className="packageNameInput" variant="outlined" value={this.state.newPackageDetails.package_name} onChange={this.handlePackageNameInput} />
                                        </div>
                                        <div className="col-1">
                                            {
                                                this.props.selectedPackageDetails.package_name === this.state.newPackageDetails.package_name ?
                                                    <CheckCircleIcon id="newProductFormGoodIndicator" />
                                                    :
                                                    this.state.newPackageDetails.package_name !== "" && this.props.uniquePackageNameCheckResult.unique ?
                                                        <CheckCircleIcon id="newProductFormGoodIndicator" />
                                                        :
                                                        <CheckCircleIcon id="newProductFormBadIndicator" />
                                            }
                                        </div>
                                    </div>
                                </div>
                                :
                                this.state.activeStep === 1 ?
                                    //THIRD STEP
                                    <div className="tokenContentInputContainer col-12">
                                        {
                                            this.state.packageType.usage === 'Class Participation' ?
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "適用年齡組別" : "Applicable Age"} :</div>
                                                    <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                        <FormControl variant="outlined" className="packageNameInput">
                                                            <Select
                                                                labelId="demo-simple-select-outlined-label"
                                                                id="demo-simple-select-outlined"
                                                                value={this.state.newPackageDetails.age_group_id}
                                                                onChange={this.handleAgeGroupInput}
                                                            >
                                                                <MenuItem value={0}>{this.props.language !== "eng" ? "不限" : "Unlimited"}</MenuItem>
                                                                {
                                                                    this.props.allAgeGroups.map((ageGroup: any) =>
                                                                        <MenuItem value={ageGroup.id}>{ageGroup.age_group}</MenuItem>
                                                                    )
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </div>
                                                : null
                                        }
                                        {
                                            this.state.packageType.usage === 'Class Participation' ?
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "適用運動種類" : "Applicable Sport"} :</div>
                                                    {
                                                        this.state.newPackageDetails.genre_id.length === 0 ?
                                                            <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                                                <div className="genreListingRow">
                                                                    <div className="suitableGenreDisplay">
                                                                        <div className="genreContainer">
                                                                            <AllInclusiveIcon /><div className="genreName">{this.props.language !== "eng" ? "不限" : "Unlimited"}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="suitableGenreDisplay" onClick={this.handleAddNewGenre}>
                                                                        <div className="genreContainer" >
                                                                            <AddIcon /><div className="genreName">{this.props.language !== "eng" ? "新增" : "Add"}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                                <div className="genreListingRow">

                                                                    {this.state.newPackageDetails.genre_id.map((genreID: number) =>
                                                                        <div className="suitableGenreDisplay" onClick={() => this.handleDelGenre(genreID)}>
                                                                            <div className="genreContainer">
                                                                                <ClearIcon /><div className="genreName">{(this.props.allGenres.filter((genre: any) => genre.id === genreID))[0].genre}</div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    <div className="suitableGenreDisplay" onClick={this.handleAddNewGenre}>
                                                                        <div className="genreContainer" >
                                                                            <AddIcon /><div className="genreName">{this.props.language !== "eng" ? "新增" : "Add"}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    }

                                                </div>
                                                : null
                                        }
                                        {
                                            this.state.packageType.usage === 'Class Participation' && this.state.addGenre ?

                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "新增運動種類" : "Add Sport Type"} :</div>
                                                    <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                                        <FormControl variant="outlined" className="packageNameInput">
                                                            <Select
                                                                labelId="demo-simple-select-outlined-label"
                                                                id="demo-simple-select-outlined"
                                                                onChange={this.handleGenreInput}
                                                            >
                                                                {
                                                                    this.props.allGenres.map((genre: any) =>
                                                                        this.state.newPackageDetails.genre_id.length === 0 ?
                                                                            <MenuItem value={genre.id}>{genre.genre}</MenuItem>
                                                                            :
                                                                            this.state.newPackageDetails.genre_id.find((genreID: number) => genreID === genre.id) ?
                                                                                null :
                                                                                <MenuItem value={genre.id}>{genre.genre}</MenuItem>
                                                                    )
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </div>
                                                : null
                                        }
                                        {
                                            this.state.packageType.usage === 'Class Participation' ?
                                                <div className=" inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "扣數類型套券" : "Token Based Package"} :</div>
                                                    <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                                        {
                                                            this.props.language !== "eng" ?
                                                                <FormControl variant="outlined" className="packageTokenBasedPackageInput">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={this.state.newPackageDetails.token_based_package}
                                                                                onChange={this.handleTokenBasedPackageChange}
                                                                                name="tokenBasedPackage"
                                                                                color="primary"
                                                                            />
                                                                        }

                                                                        label="扣數類型套券"
                                                                    />
                                                                </FormControl>
                                                                :
                                                                <FormControl variant="outlined" className="packageTokenBasedPackageInput">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={this.state.newPackageDetails.token_based_package}
                                                                                onChange={this.handleTokenBasedPackageChange}
                                                                                name="tokenBasedPackage"
                                                                                color="primary"
                                                                            />
                                                                        }

                                                                        label="Token Based Package"
                                                                    />
                                                                </FormControl>
                                                        }
                                                    </div>
                                                </div>
                                                :
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "扣數類型套券" : "Token Based Package"} :</div>
                                                    <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                                        {
                                                            this.props.language !== "eng" ?
                                                                <FormControl variant="outlined" className="packageTokenBasedPackageInput">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={this.state.newPackageDetails.token_based_package}
                                                                                onChange={this.handleTokenBasedPackageChange}
                                                                                name="tokenBasedPackage"
                                                                                color="primary"
                                                                                disabled
                                                                            />
                                                                        }

                                                                        label="扣數類型套券"
                                                                    />
                                                                </FormControl>
                                                                :
                                                                <FormControl variant="outlined" className="packageTokenBasedPackageInput">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={this.state.newPackageDetails.token_based_package}
                                                                                onChange={this.handleTokenBasedPackageChange}
                                                                                name="tokenBasedPackage"
                                                                                color="primary"
                                                                                disabled
                                                                            />
                                                                        }

                                                                        label="Token Based Package"
                                                                    />
                                                                </FormControl>
                                                        }
                                                    </div>
                                                </div>
                                        }
                                        {
                                            this.state.newPackageDetails.token_based_package ?
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "內含套券數量" : "Included Token"} :</div>
                                                    <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                        <FormControl variant="outlined" className="packageNameInput">
                                                            <TextField variant="outlined" value={this.state.newPackageDetails.token_amount} onChange={this.handleTokenAmountInput} />
                                                        </FormControl>
                                                    </div>
                                                </div>
                                                :
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "內含套券數量" : "Included Token"} :</div>
                                                    <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                        <FormControl variant="outlined" className="packageNameInput">
                                                            <TextField variant="outlined" value={this.state.newPackageDetails.token_amount} onChange={this.handleTokenAmountInput} disabled />
                                                        </FormControl>
                                                    </div>
                                                </div>
                                        }
                                        {
                                            this.state.packageType.usage === 'Private Class Booking' || this.state.packageType.usage === 'Classroom Rental' ?
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "套券生效時長" : "Effective Time"} :</div>
                                                    <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                        <FormControl variant="outlined" className="packageNameInput">
                                                            {
                                                                this.state.newPackageDetails.effective_time === 0 || this.state.newPackageDetails.effective_time >= 45 && this.state.newPackageDetails.effective_time % 15 === 0 ?
                                                                    <TextField variant="outlined" type="number" helperText="1.準確至十五分鐘 2.最少45分鐘 (e.g 一個半小時 請輸入 -> 90)" value={this.state.newPackageDetails.effective_time} onChange={this.handleEffectiveTimeInput} placeholder="以分鐘作單位" />
                                                                    :
                                                                    <TextField variant="outlined" type="number" helperText="1.準確至十五分鐘 2.最少45分鐘 (e.g 一個半小時 請輸入 -> 90)" value={this.state.newPackageDetails.effective_time} onChange={this.handleEffectiveTimeInput} placeholder="以分鐘作單位" error />

                                                            }
                                                        </FormControl>
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }
                                        {
                                            <div className="inputRowOnAddPackageComponent row">
                                                <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "套券有效日數" : "Valid Period"} :</div>
                                                <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                    <FormControl variant="outlined" className="packageNameInput">
                                                        <TextField variant="outlined" value={`${this.state.newPackageDetails.validate_period} `} onChange={this.handleValidatePeriodInput} />
                                                    </FormControl>
                                                </div>
                                            </div>
                                        }
                                        {
                                            <div className="inputRowOnAddPackageComponent row">
                                                <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "設定套券價格" : "Package Price"} :</div>
                                                <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                    <FormControl variant="outlined" className="packageNameInput">
                                                        <TextField variant="outlined" value={`${this.state.newPackageDetails.price}`} onChange={this.handlePriceInput} />
                                                    </FormControl>
                                                </div>
                                            </div>
                                        }
                                        {
                                            <div className="inputRowOnAddPackageComponent row">
                                                <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "設定分校限制" : "Site Limitation"} :</div>
                                                <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                    <FormControl variant="outlined" className="packageNameInput">
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            value={this.state.newPackageDetails.site_id}
                                                            onChange={this.handleSiteInput}
                                                        >
                                                            <MenuItem value={0}>{this.props.language !== "eng" ? "不限" : "Unlimited"}</MenuItem>
                                                            {
                                                                this.props.allSites.map((site: any) =>
                                                                    <MenuItem value={site.id}>{site.site_key}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    :
                                    this.state.activeStep === 2 ?
                                        <div className="tokenTermsInputContainer col-12">
                                            {
                                                this.props.allTerms.map((term: any) =>
                                                    term.active && !term.base_terms ?
                                                        this.state.newPackageDetails.package_terms && this.state.newPackageDetails.package_terms.includes(term.id) ?
                                                            <div className="inputRowOnAddPackageComponent row" onClick={() => this.handleTermsClick(term.id)}>
                                                                <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "條款" : "Terms"} :</div>
                                                                <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                                    <div className="inlineDisplay selectedTermDetailsDisplayFieldOnAddPackageComponent"> {term.content} </div>
                                                                </div>
                                                                <div className="col-1">
                                                                    <CheckIcon id="displaySelectedTermIndicator" />
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="inputRowOnAddPackageComponent row" onClick={() => this.handleTermsClick(term.id)}>
                                                                <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "條款" : "Terms"} :</div>
                                                                <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                                    <div className="inlineDisplay termDetailsDisplayFieldOnAddPackageComponent"> {term.content} </div>
                                                                </div>
                                                                <div className="col-1">
                                                                    <CheckIcon id="hiddenSelectedTermIndicator" />
                                                                </div>
                                                            </div>
                                                        : null
                                                )
                                            }
                                        </div>
                                        :
                                        this.state.activeStep === 3 ?
                                            <div className="tokenTermsInputContainer">
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "暫定套券種類" : "Package Type"} :</div>
                                                    <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                        <div className="packageContentDisplayOnAddPackageComponent" > {this.state.packageType.usage === 'Class Participation' ? "課堂套券" : this.state.packageType.usage === 'Private Class Booking' ? "私人堂套券" : this.state.packageType.usage === 'Classroom Rental' ? "場地套券" : this.state.packageType.usage === "Tutor Rental" ? "導稱套券" : null}  </div>
                                                    </div>
                                                </div>
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "暫定套券名稱" : "Package Name"} :</div>
                                                    <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                        <div className="packageContentDisplayOnAddPackageComponent" > {this.state.newPackageDetails.package_name}  </div>
                                                    </div>
                                                </div>
                                                {this.state.packageType.usage === 'Class Participation' ?
                                                    <div className="inputRowOnAddPackageComponent row">
                                                        <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "適用年齡組別" : "Applicable Age"} :</div>
                                                        <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                            <div className="packageContentDisplayOnAddPackageComponent" > {
                                                                this.state.newPackageDetails.age_group_id === 0 ? this.props.language !== "eng" ? "不限" : "Unlimited" :
                                                                    (this.props.allAgeGroups.filter((ageGroup: any) => ageGroup.id === this.state.newPackageDetails.age_group_id))[0].age_group
                                                            }  </div>
                                                        </div>
                                                    </div>
                                                    : null}
                                                {this.state.packageType.usage === 'Class Participation' ?
                                                    <div className="inputRowOnAddPackageComponent row">
                                                        <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "適用運動種類" : "Applicable Sport"} :</div>
                                                        <div className="col-xl-5 col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                                            {
                                                                this.state.newPackageDetails.genre_id.length === 0 ?
                                                                    <div className="genreListingRow">
                                                                        <div className="suitableGenreDisplay">
                                                                            <div className="genreContainer">
                                                                                <AllInclusiveIcon /><div className="genreName">{this.props.language !== "eng" ? "不限" : "Unlimited"}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div className="genreListingRow">
                                                                        {this.state.newPackageDetails.genre_id.map((genreID: number) =>
                                                                            <div className="suitableGenreDisplay" onClick={() => this.handleDelGenre(genreID)}>
                                                                                <div className="genreContainer">
                                                                                    <div className="genreName">{(this.props.allGenres.filter((genre: any) => genre.id === genreID))[0].genre}</div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    : null}
                                                {
                                                    <div className="inputRowOnAddPackageComponent row">
                                                        <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "扣數類型套券" : "Token Based Package"} :</div>
                                                        {
                                                            this.props.language !== "eng" ?
                                                                <FormControl variant="outlined" className="packageTokenBasedPackageInput">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={this.state.newPackageDetails.token_based_package}
                                                                                onChange={this.handleTokenBasedPackageChange}
                                                                                name="tokenBasedPackage"
                                                                                color="primary"
                                                                                disabled
                                                                            />
                                                                        }

                                                                        label="扣數類型套券"
                                                                    />
                                                                </FormControl>
                                                                :
                                                                <FormControl variant="outlined" className="packageTokenBasedPackageInput">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={this.state.newPackageDetails.token_based_package}
                                                                                onChange={this.handleTokenBasedPackageChange}
                                                                                name="tokenBasedPackage"
                                                                                color="primary"
                                                                                disabled
                                                                            />
                                                                        }

                                                                        label="token Based Package"
                                                                    />
                                                                </FormControl>
                                                        }
                                                    </div>

                                                }
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "內容套券數量" : "Token Included"} :</div>
                                                    <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                        <div className="packageContentDisplayOnAddPackageComponent" > {this.state.newPackageDetails.token_amount} {this.props.language !== "eng" ? "張" : ""} </div>
                                                    </div>
                                                </div>
                                                {
                                                    this.state.packageType.usage === "Classroom Rental" || this.state.packageType.usage === "Private Class Booking" ?
                                                        <div className="inputRowOnAddPackageComponent row">
                                                            <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "套券生效時長" : "Effective Time"} :</div>
                                                            <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                                <div className="packageContentDisplayOnAddPackageComponent" > {this.state.newPackageDetails.effective_time} {this.props.language !== "eng" ? "分鐘" : "Min"}</div>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "套券有效日數" : "Valid Period"} :</div>
                                                    <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                        <div className="packageContentDisplayOnAddPackageComponent" > {this.state.newPackageDetails.validate_period} {this.props.language !== "eng" ? "日" : "Days"} </div>
                                                    </div>
                                                </div>
                                                <div className="inputRowOnAddPackageComponent row">
                                                    <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "暫定套券價格" : "Package Price"} :</div>
                                                    <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                        <div className="packageContentDisplayOnAddPackageComponent" > $ {this.state.newPackageDetails.price} </div>
                                                    </div>
                                                </div>
                                                {
                                                    <div className="inputRowOnAddPackageComponent row">
                                                        <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "設定分校限制" : "Site Limitation"} :</div>
                                                        <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                            <div className="packageContentDisplayOnAddPackageComponent" > {
                                                                this.state.newPackageDetails.site_id === 0 ? this.props.language !== "eng" ? "不限" : "Unlimited" :
                                                                    (this.props.allSites.filter((site: any) => site.id === this.state.newPackageDetails.site_id))[0].site_key
                                                            }  </div>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    this.state.newPackageDetails.package_terms ?
                                                        <div className="inputRowOnAddPackageComponent row">
                                                            <div className="tokenNameLabel col-xl-2 offset-xl-1 col-lg-3 offset-lg-1 col-md-4 offset-md-1  col-sm-12 offset-sm-0 col-xs-12 offset-xs-0">{this.props.language !== "eng" ? "暫定掛勾條款" : "Package Terms"} :</div>
                                                            <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                                                <div className="packageContentDisplayOnAddPackageComponent">
                                                                    {this.state.newPackageDetails.package_terms.map((termID: any) =>
                                                                        <div className="termIndividualContainer">
                                                                            - {(this.props.allTerms.filter((term: any) => term.id === termID))[0].content}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                            :
                                            null

                        }
                    </div>
                </div>
                <div className="modifyStepsRow">
                    {this.state.activeStep === 0 ? <Button id="stepButtonNoShow" disabled>{this.props.language !== "eng" ? "上一步" : "Back"}</Button> : <Button id="stepButton" onClick={this.handlePreviousStepClick}>{this.props.language !== "eng" ? "上一步" : "Back"}</Button>}
                    {
                        this.state.activeStep === 0 && this.props.selectedPackageDetails.package_name === this.state.newPackageDetails.package_name ?
                            <Button id="stepButton" onClick={this.handleNextStepClick}>{this.props.language !== "eng" ? "下一步" : "Next"}</Button>
                            :
                            this.state.activeStep === 0 && this.state.newPackageDetails.package_name !== '' && this.props.uniquePackageNameCheckResult.unique ?
                                <Button id="stepButton" onClick={this.handleNextStepClick}>{this.props.language !== "eng" ? "下一步" : "Next"}</Button>
                                :
                                this.state.activeStep === 1 && (this.state.newPackageDetails.token_usage_id === 3 ? this.state.newPackageDetails.effective_time !== 0 && this.state.newPackageDetails.effective_time % 15 === 0 && this.state.newPackageDetails.effective_time >= 45 : true) && (this.state.newPackageDetails.token_usage_id === 2 ? this.state.newPackageDetails.effective_time !== 0 && this.state.newPackageDetails.effective_time % 15 === 0 && this.state.newPackageDetails.effective_time >= 45 : true) ?
                                    <Button id="stepButton" onClick={this.handleNextStepClick}>{this.props.language !== "eng" ? "下一步" : "Next"}</Button>
                                    :
                                    this.state.activeStep === 2 ?
                                        <Button id="stepButton" onClick={this.handleNextStepClick}>{this.props.language !== "eng" ? "下一步" : "Next"}</Button>
                                        :
                                        this.state.activeStep === 3 ?
                                            <Button id="stepButton" onClick={this.handleShowEditSoldPackageConfirmationBoxBtn}>{this.props.language !== "eng" ? "確定更改套券" : "Confirm Edit Package"}</Button>
                                            :
                                            <Button id="stepButtonDisabled" onClick={this.handleNextStepClick} disabled>{this.props.language !== "eng" ? "下一步" : "Next"}</Button>


                    }
                </div>
            </div>
        )
    }
}

// export default connect(mapStateToProps, mapDispatchToProps)(EditPackageComponent);
export default EditPackageComponent